import { Platform, StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { borderRadiusFull, colorBgInteractiveActive, colorIconLight, space1, space2, space3, iconSizeSmall } = theme();
    const ICON_SIZE = iconSizeSmall;
    return StyleSheet.create({
        button: {
            padding: 0,
        },
        container: {
            alignItems: "center",
            backgroundColor: colorBgInteractiveActive,
            borderRadius: borderRadiusFull,
            flexDirection: "row",
            height: 32,
            maxWidth: "100%",
            paddingLeft: space3,
            paddingRight: space1,
            paddingVertical: space2,
        },
        icon: {
            color: colorIconLight,
            fontSize: ICON_SIZE,
            height: ICON_SIZE,
            lineHeight: ICON_SIZE,
            minHeight: ICON_SIZE,
            minWidth: ICON_SIZE,
            width: ICON_SIZE,
        },
        text: {
            overflow: "hidden",
            ...Platform.select({
                web: {
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                },
                native: {
                    paddingTop: 0,
                },
            }),
        },
    });
};
export { style };
